<template>
    <div id="foot">
        <span id="_ideConac"><a href="https://bszs.conac.cn/sitename?method=show&amp;id=3B1CC842AA299BDFE06310291AAC085A" target="_blank"><img id="imgConac" vspace="0" hspace="0" border="0" src="https://dcs.conac.cn/image/nis/blue.png" data-bd-imgshare-binded="1"></a></span>
        <div id="foot-area" style="line-height: 80px;">
            <div class="bot-nav-area">
                <ul style="height: 80px; line-height: 80px;">
                    <!-- <li><a href="#">关于我们</a></li>
                    <li><a href="#">联系我们</a></li> -->
                    <li style="line-height: 80px"><a href="#">技术支持：</a><a style="color:#409EFF;" href="#">广东深蓝智能软件有限公司</a></li>
                </ul>
            </div>
            <a class="bah" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：粤ICP备2022099647号-1</a>
            <div class="cr">
                汕头龙湖工业园区管理办公室版权所有
            </div>
        </div>        
    </div>
</template>
<script>
    export default {
        name: 'Footer',
        data() {
            return {}
        }
    }
</script>
<style>
#foot {    
    margin-top: 14px;
    display: flex;
    justify-content: center;
}
#foot-area {
    width: 1200px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}
.bot-nav-area {
    padding-left: 10px;
}
.bot-nav-area ul {
    display: flex;
}
.bot-nav-area li {
    border-right: 1px solid #7e8c97;
    padding: 0 6px;
    line-height: 14px;
}
.bot-nav-area li:last-child {
    border: none;
}
.bot-nav-area a {
    color: #7e8c97;
    font-size: 12px;
}
.cr {
    color: #7e8c97;
    font-size: 12px;
}
.bah {
    color: #7e8c97;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue